import axios from "../../service";
import alert from "@/_helpers/alert";
import moment from "moment";
import fn from "@/helpers/utility";
import { UserService } from "../resources";
export const state = {
  userProfile: {},
  optDelete: {
    telephone: "",
    otp: "",
    ref: ""
  },
  keyAuth: {
    key: "setting_flag",
    keyAdvance: "advanced_setting_flag"
  }
};

export const mutations = {
  SET_OTP_DELETE(state, newValue) {
    state.optDelete = newValue;
  },
  SET_USER_PROFILE(state, newValue) {
    state.userProfile = newValue;
  },

  UPDATE_USER_PROFILE(state, newValue) {
    Object.assign(state.userProfile, {
      name: newValue.name,
      profile_pic: newValue.url
    });
  }
};

export const getters = {
  otpDelete(state) {
    return state.optDelete;
  },
  PermissionFlag(state) {
    return fn.PermissionFlag(state.keyAuth.keyAdvance);
  }
};

export const actions = {
  // async fetchProfile({ commit }) {
  //   try {
  //     let resp = await axios.get("/user/information");
  //     if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองหใม่ภายหลัง!";
  //     commit("SET_USER_PROFILE", resp.data[0].user);
  //     return { status: true };
  //   } catch (error) {
  //     return { status: false, err: error };
  //   }
  // },

  // async updateUserProfile({ commit }, data) {
  //   try {
  //     let resp = await axios.put("/user/information", {
  //       name: data.name,
  //       email: data.email,
  //       newPass: data.newPass,
  //       rePass: data.rePass,
  //       oldPass: data.oldPass,
  //       otpFlag: data.otpFlag
  //     });
  //     if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง!";
  //     if (data.image) {
  //       let formData = new FormData();
  //       formData.append("file", data.image);
  //       let updateProfile = await axios.post("/user/information/profile", formData);
  //       if (!updateProfile) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง!";
  //       commit("UPDATE_USER_PROFILE", { name: data.name, url: updateProfile.data[0].filename });
  //       commit("auth/UPDATE_USER_IMAGE", { name: data.name, url: updateProfile.data[0].filename }, { root: true });
  //     } else {
  //       commit("UPDATE_USER_PROFILE", { name: data.name });
  //       commit("auth/UPDATE_USER_NAME", { name: data.name }, { root: true });
  //     }
  //     return { status: true };
  //   } catch (error) {
  //     return { status: false, err: error };
  //   }
  // },

  // async updatePersonal(_, data) {
  //   try {
  //     let formData = new FormData();
  //     formData.append("file", data.image);
  //     delete data.image;
  //     formData.append("data", JSON.stringify(data));
  //     let resp = await axios.put("/user/information", formData);
  //     if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง!";
  //     if (!resp.data[0].success) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง ";
  //     return { status: true };
  //   } catch (error) {
  //     return { status: false, err: error };
  //   }
  // },

  async updateCompany(_, data) {
    try {
      let formData = new FormData();
    } catch (error) {
      return { status: false, err: error };
    }
  },

  // async verifyCard(_, data) {
  //   try {
  //     const formData = new FormData();
  //     formData.append("file", data.imgCard);
  //     let resp = await axios.post("/user/information/verify-card", formData, {
  //       params: {
  //         ...data.profile,
  //       },
  //     });
  //     if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองหใม่ภายหลัง!";
  //     return { status: true, waiting: resp.data[0].verify_status };
  //   } catch (err) {
  //     return { status: false, err: err };
  //   }
  // },

  // async verifyBank(_, data) {
  //   try {
  //     const formData = new FormData();
  //     formData.append("file", data.imgCard);
  //     let resp = await axios.post("/user/information/verify-bank", formData, {
  //       params: {
  //         ...data.profile,
  //       },
  //     });
  //     if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองหใม่ภายหลัง!";
  //     return { status: true, waiting: resp.data[0].verify_status };
  //   } catch (err) {
  //     return { status: false, err: err };
  //   }
  // },

  async proFile({ commit, dispatch, getters }, data) {
    try {
      let resp = await UserService.apiGetprofile(data);
      return { status: true, ...resp.data };
    } catch (err) {
      console.error(err.message, "err.message");
      alert.error("เกิดขอผิดพลาด");
    }
  },

  async uploadProfile({ commit, dispatch, getters }, data) {
    try {
      let resp = await axios({
        method: "POST",
        url: `${process.env.VUE_APP_ENDPOINT_BACKEND}/client/v1/upload/${data.idAccount}/file`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data"
        },
        data: data.formData
      })
        .then(success => {
          return success;
        })
        .catch(err => {
          console.error(err.message, "message-upload-profile");
          console.error(err, "err");
          alert.error(err.message);
          return err.message;
        });
      if (!resp) {
        return { status: false, data: {}, message: resp };
      } else {
        return {
          status: true,
          data: resp?.data,
          date: moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
        };
      }
    } catch (err) {
      console.error(err.message, "err.message");
      alert.error("เกิดขอผิดพลาด");
    }
  },

  async updateProfile({ commit, dispatch, getters }, data) {
    try {
      let resp = await UserService.apiEditupdateProfile(data);
      return { status: true, ...resp.data };
    } catch (err) {
      console.error(err.message, "err.message");
      alert.error("เกิดขอผิดพลาด");
    }
  },

  async getOtpForDelete({ commit, dispatch, getters }, telephone) {
    try {
      let resp = await UserService.apiDeleteGetOtpForDelete(telephone);
      return { status: true, ...resp.data };
    } catch (err) {
      console.error(err.message, "err.message");
      alert.error("เกิดขอผิดพลาด");
    }
  },

  async deleteAccount({ commit, dispatch, getters }, data) {
    try {
      let resp = await UserService.apiDeleteAccount(data);
      return { status: true, ...resp.data };
    } catch (err) {
      console.error(err.message, "err.message");
      alert.error("เกิดขอผิดพลาด");
    }
  },

  async updateProfileMultiple({ commit, dispatch, getters }, formData) {
    try {
      let resp = await axios({
        method: "POST",
        url: `${process.env.VUE_APP_ENDPOINT_BACKEND}/client/v1/upload/file`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data"
        },
        data: formData
      })
        .then(success => {
          return success;
        })
        .catch(err => {
          console.error(err.message, "message-Register");
          console.error(err, "err");
          alert.error(err.message);
          return err.message;
        });
      if (resp?.data) {
        return resp?.data;
      }
    } catch (err) {
      console.error(err.message, "err.message");
      alert.error("เกิดขอผิดพลาด");
    }
  },

  async updatePeolpleNormal({ commit, dispatch, getters }, data) {
    try {
      let resp = await UserService.apiEditupdatePeolpleNormal(data);
      return { status: true, ...resp };
    } catch (err) {
      console.error(err.message, "err.message");
      alert.error("เกิดขอผิดพลาด");
    }
  },

  async updateJuristicVerify({ commit, dispatch, getters }, data) {
    try {
      let resp = await UserService.apiEditupdateJuristicVerify(data);
      return { status: true, ...resp.data };
    } catch (err) {
      console.error(err.message, "err.message");
      alert.error("เกิดขอผิดพลาด");
    }
  },

  async updateCod({ commit, dispatch, getters }, data) {
    try {
      let resp = await UserService.apiEditupdateCod(data);
      if (resp?.data) {
        return resp?.data;
      }
    } catch (err) {
      console.error(err.message, "err.message");
      alert.error("เกิดขอผิดพลาด");
    }
  },

  async verifyEmail({ commit }, email) {
    try {
      let resp = await UserService.apiGetverifyEmail(email);
      return { status: true, ...resp };
    } catch (err) {
      console.error(err.message, "err.message");
      alert.error("เกิดขอผิดพลาด");
    }
  },

  async verifyEmailOtp({ commit }, data) {
    try {
      let resp = await UserService.apiCreateverifyEmailOtp(data);
      return { status: true, ...resp };
    } catch (err) {
      console.error(err.message, "err.message");
      alert.error("เกิดขอผิดพลาด");
    }
  },

  async getNotification({ commit }, data) {
    try {
      let resp = await UserService.apiGetNotification(data);
      return { status: true, ...resp };
    } catch (err) {
      console.error(err.message, "err.message");
      alert.error("เกิดขอผิดพลาด");
    }
  },

  async readNotification({ commit }, id) {
    try {
      let resp = await UserService.apiEditreadNotification(id);
    } catch (err) {
      console.error(err.message, "err.message");
      alert.error("เกิดขอผิดพลาด");
    }
  },

  async updateConfigNoti({ commit }, data) {
    try {
      let resp = await UserService.apiEditupdateConfigNoti(data);
      return { status: true, ...resp };
    } catch (err) {
      console.error(err.message, "err.message");
      alert.error("เกิดขอผิดพลาด");
    }
  }
};
